export const WHATS_APP_PHONE_NUMBER = process.env.REACT_APP_PHONE_NUMBER || '-';
